var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMsShopSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5925C4 10.287 4.13971 9.99816 4.3793 9.80849L3.75859 9.02445L4.3793 9.80849L11.3793 4.26683C11.743 3.97889 12.257 3.97889 12.6207 4.26683L19.6207 9.80849C19.8603 9.99816 20 10.287 20 10.5925V19.5C20 20.0523 19.5523 20.5 19 20.5H5C4.44771 20.5 4 20.0523 4 19.5V10.5925Z",
    stroke: "#FFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15L13 15ZM13 21L13 15L11 15L11 21L13 21Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsShopSelected);
export default __webpack_public_path__ + "static/media/ic_ms_shop_selected.c541dedcf2fae918e2e0f4baf837d8f2.svg";
export { ForwardRef as ReactComponent };